<template>
    <div id="contenedor-seccion-logo-intranet" class="container-fluid">
      <div class="row">
          <CSeccionLogoUsuario></CSeccionLogoUsuario>
          <CMenuHorizontal></CMenuHorizontal>
      </div>
    </div>
</template>
<script>
import CSeccionLogoUsuario from "@/components/Intranet/Comun/Estructura/Header/CSeccionLogoUsuario.vue";
import CSeccionAcciones from "@/components/Intranet/Comun/Estructura/Header/CSeccionAcciones.vue";
import CMenuHorizontal from "@/components/Intranet/Comun/CMenuHorizontal.vue";

export default {
    components: {
        CSeccionLogoUsuario: CSeccionLogoUsuario,
        CSeccionAcciones: CSeccionAcciones,
        CMenuHorizontal: CMenuHorizontal
    }
}
</script>
<style scoped>
#contenedor-seccion-logo-intranet {
    background-color: #000000;
    min-height: 9vh;
    color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Comun/Estructura/Header/CHeader.vue